import React, {Fragment, useEffect, useRef, useState} from "react";
import * as ReactDOM from 'react-dom';
import {Badge, Button, Card, CardBody, Col, FormGroup, Input, Label} from "reactstrap";
import Select from "react-select";
import JqxTable from "../../../../../share-components/table/JqxTable";
import {toast} from "react-toastify";
import JqxGrid, {IGridProps, jqx} from './../../../../../custom_modules/jqx/jqwidgets-react-tsx/jqxgrid';
import {forEach} from "react-bootstrap/ElementChildren";
import {
    packPriceCalculation,
    singleCalculation,
    singlePackCalculation,
    singlePriceCalculation
} from "./settings/calculation";
import * as ReactDOMServer from "react-dom/server";
import MediaModal from "./mediaModal";
import {useDispatch, useSelector} from "react-redux";
import {setMediaDialog, setSkuDialog} from "../../../store/prodcutSlice";
import {Popover, PopoverBody, PopoverHeader} from "react-bootstrap";
import SkuDetails from "./skuDetails";

// const dataSizeRatio = [
//     {size: 1, ratio: 2},
//     {size: 3, ratio: 4},
//     {size: 4, ratio: 8},
// ];
let currentIndex="";
let currentEditedCell="";
const VariationJsx = (props) => {
    const {setValue, getValues, trigger,productState,modules,currentUser, hasMysteryTag} = props;
    let gridRef = useRef(null);
    let subGrid = useRef([]);

    let selectRef = useRef(null);
    const [isModalOpen,setIsModalOpen]=useState(false);
    const [gridDAta, setGridData] = useState(getValues('variation_configurations'));
    const [subGridHeight, setSubGridHeight] = useState(180);
    const dispatch = useDispatch();
    const has_single_price=modules.includes('has-single-price');
    const hasEditPermission=(currentUser.permission).includes('Edit Inventory');
    const sizeConfigure = useSelector(({product}) => product.sizeConfigureQuantity);



    //const roleRegister = register("role", { required: true });
    const datafields = [
        {name: 'colour_id', type: 'id'},
        {name: 'no_of_total_pack', type: 'number'},
        {name: 'colour', type: 'string'},
        {name: 'image', type: 'string'},
        {name: 'image_id', type: 'number'},
        {name: 'place_in_packs', type: 'number'},
        {name: 'pack_qty', type: 'number'},
        {name: 'pack_for_single', type: 'number'},
        {name: 'no_piece_in_pack', type: 'number'},
        {name: 'variations', type: 'array'},
        {name: 'size_images', type: 'object'},
    ];
    const columns = [
        {datafield: 'colour_id', hidden: true},
        {datafield: 'image_id', hidden: true},
        {datafield: 'no_of_total_pack', hidden: true},
        {
            text: 'Colour',
            datafield: 'colour',
            editable: false,
            cellclassname: 'rowColor',

        },
        {
            text: 'image',
            datafield: 'image',
            editable: false,
            cellsalign: 'right',
            cellclassname: 'rowColor',
            cellsrenderer(row, columnfield, value, defaulthtml, columnproperties) {
                const html = ReactDOMServer.renderToString(
                    <div style={{ textAlign: 'center', marginTop: 3 }}>
                        <img className="img-fluid" src={value?value:require('../../../../../assets/images/default-medium-product.jpeg')} width="30" height="30" alt="" />
                    </div>
                );
                return html;
            },
            cellclick(row) {
                alert(row);
            },


        },
        {
            text: 'Total Quantity',
            datafield: 'no_piece_in_pack',
            editable: false,
            cellsalign: 'right',
            width: '150',
            cellclassname: 'rowColor'

        },
        {
            text: 'Piece in Packs',
            datafield: 'place_in_packs',
            editable: false,
            cellsalign: 'right',
            width: '150',
            cellclassname: 'rowColor'

        },
        {
            text: 'Pack Qty',
            datafield: 'pack_qty',
            editable: false,
            cellsalign: 'right',
            width: '150',
            cellclassname: 'rowColor'

        },
        {
            text: 'Packs for Single Pcs',
            datafield: 'pack_for_single',
            editable: true,
            columntype: 'text',
            cellsalign: 'right',
            width: '150',
            cellclassname: 'rowColor',
            headerclassname: 'rowColor',
            validation: function (cell, value) {
                const totalPack = gridRef.getcellvalue(cell.row, 'no_of_total_pack');
                if (Number(totalPack) < Number(value)) {
                    toast.error("should be less than or equal no of pack (" + totalPack + ")", {
                        position: toast.POSITION.TOP_RIGHT,
                    });
                    return {result: false, message: "should be less than no of pack (" + totalPack + ")"}
                } else {
                    return true;

                }
            },
            cellendedit: function (row, datafield, columntype, oldvalue, value) {
                if (value) {
                    singlePackCalculation(null, null, getValues('size'), subGrid, gridRef, row, value);
                    // alert("test");
                    let colourData= [];
                    const rowData = gridRef.getrowdata(row);
                    getValues('color').map((rationItem, rationIndex) => {
                        if(rationItem.id == rowData.colour_id){
                            rationItem.pack_for_single=value;
                        }
                        colourData.push(rationItem);
                    });
                    setValue('color',colourData);
                    // setValue('color_value_change',!getValues('color_value_change'));
                    // trigger('color_value_change');
                }
            }
        }


    ];


    useEffect(() => {
        let variationData = [];

        getValues('color').forEach(item => {
            if(item.id) {
                let totalPieceInPack = 0;
                const price=getValues('sale_price')?getValues('sale_price'):getValues('price');
                const isPercentage=has_single_price?getValues('sale_price')?false:true:false;
                getValues('size').map((sizeItem, subIndex) => {
                    totalPieceInPack += Number(sizeItem.ratio);
                });
                let subData = [{type: "total", price: '', total_qty: ""},
                    {type: "pack", price: packPriceCalculation(totalPieceInPack, price), total_qty: ""}];

                if (getValues('selling_type').length > 1) {
                    subData.push({
                        type: "single",
                        price: singlePriceCalculation(Number(price),isPercentage),
                        total_qty: ""
                    })
                } else {
                    subData.push({type: "Broken Pcs", price: '', total_qty: ""})
                }
                if (getValues('selling_type').length < 2 && getValues('selling_type').length > 0) {
                    if (getValues('selling_type').find(x => x.id === 1)) {
                        subData.length = 0;
                        subData.push({type: "total", price: singlePriceCalculation(Number(price),isPercentage), total_qty: ""})
                        setSubGridHeight(110);
                    } else {
                        setSubGridHeight(181)
                    }
                } else {
                    setSubGridHeight(180)
                }
                let existMainData = getValues('variation_configurations').find(x => x.colour_id == item.id);
                subData.map((item, index) => {
                    let existSubData = null;
                    if (existMainData && index == 0) {
                        existSubData = (existMainData.variations).find(x => x.type == 'total');
                    }
                    getValues('size').map((sizeItem, subIndex) => {
                        item[sizeItem.id] = existSubData ? (existSubData[sizeItem.id] ? existSubData[sizeItem.id] : 0) : 0;
                    });

                });

                // Add image row for size-level images at the top (just below header)
                const existSizeImages = existMainData && existMainData.size_images ? existMainData.size_images : {};
                const imageRow = { type: 'image', price: '', total_qty: '' };
                getValues('size').map((sizeItem) => {
                    const sizeImg = existSizeImages[sizeItem.id];
                    imageRow[sizeItem.id] = sizeImg ? sizeImg.image_id : 0;
                });
                subData.unshift(imageRow);

                variationData.push({
                    colour_id: item.id,
                    colour: item.name + "  "+getColourStar(item.id),
                    place_in_packs: existMainData ? existMainData.place_in_packs : "",
                    pack_qty: existMainData ? existMainData.pack_qty : "",
                    pack_for_single:  (item.pack_for_single?item.pack_for_single:existMainData ? existMainData.pack_for_single:0),
                    no_piece_in_pack: existMainData ? existMainData.no_piece_in_pack : "",
                    no_of_total_pack: existMainData ? existMainData.no_of_total_pack : "",
                    image: existMainData ? existMainData.image : item.product_image_url,
                    image_id: existMainData ? existMainData.image_id : item.product_image_id,
                    size_images: existMainData && existMainData.size_images ? existMainData.size_images : {},
                    variations: subData
                })
            }
        });

        setValue('variation_configurations', variationData);
        setGridData(variationData);

        const finalData = applyMysteryTag(variationData);

        setValue("variation_configurations", finalData);
        setGridData(finalData);

    }, [getValues('selling_type'), getValues('color'), getValues('size'),getValues('value_change'),isModalOpen, hasMysteryTag, sizeConfigure]);

    const applyMysteryTag = (variationConfigs) => {
        if (!hasMysteryTag) return variationConfigs;

        return variationConfigs.map(item => ({
            ...item,
            variations: item.variations.map(variation => {
                if (variation.type === 'image') return variation;
                const updated = { ...variation };
                Object.keys(updated).forEach(key => {
                    if (key !== 'type' && key !== 'price' && sizeConfigure?.[key] !== undefined) {
                        // Use sizeConfigure value instead of 0
                        updated[key] = sizeConfigure[key];
                    }
                });
                return updated;
            })
        }));
    };

    
    useEffect(() => {


        if (getValues('selling_type').length < 2) {
            if (getValues('selling_type').find(x => x.id === 2)) {
                gridRef.hidecolumn('pack_for_single');
            } else {
                gridRef.hidecolumn('place_in_packs');
                gridRef.hidecolumn('pack_qty');
                gridRef.hidecolumn('pack_for_single');
                gridRef.hidecolumn('no_piece_in_pack');
            }
        } else {
            gridRef.hidecolumn('no_piece_in_pack')

        }

    }, [gridDAta]);

    useEffect(() => {
        setTimeout(
            () => {
                // gridRef.showrowdetails(0);
                // getValues('color').map((create, i) => {
                //     if(i<4) {
                //          gridRef.showrowdetails(i);
                //     }
                //
                // });

            }, 1000);
    }, [gridDAta])


    const getJqxRef = jqx => {
        if (jqx) {
            gridRef = jqx;



            setTimeout(
                () => {
                    if (gridRef) {

                        const myEle = document.getElementById(gridRef._id);
                        if (myEle) {
                             gridRef.updatebounddata();

                            getValues('color').map((item, i) => {
                                if(i<5) {
                                   gridRef.showrowdetails(i);

                                }

                            });
                        }
                    }

                    // myGrid.updatebounddata();
                },
                1000
            );
        }
    };


    const divRef = useRef(null);
    const cellEdit = event => {
        setTimeout(
            () => {
             setGridDataToHookForm(event.args.rowindex);
        },500)

    };
    const setGridDataToHookForm = (index)=>{

        let variationData = getValues('variation_configurations');
        const myEle =subGrid.current[index]? document.getElementById(subGrid.current[index]._id):"";
        if(myEle) {

                    const subGridInformation = subGrid.current[index].getdatainformation();
                    let variationPackDetails = [];
                    for (let k = 0; k < subGridInformation.rowscount; k++) {
                        const rowData = subGrid.current[index].getrowdata(k);
                        if (rowData.type === 'image') {
                            // Skip image row — size_images are managed by imageSelectOnClick
                            continue;
                        }
                        variationPackDetails.push(rowData);
                    }
                    const rowData = gridRef.getrowdata(index);
                    rowData['variations'] = variationPackDetails;
                    // Preserve size_images from form state (managed by imageSelectOnClick)
                    rowData['size_images'] = variationData[index]?.size_images || {};
                    variationData[index] = rowData;



        }
    }


    const nestedGrids = [];
    const initrowdetails = (index, parentElement, gridElement, record) => {
        const id = record.uid.toString();
        const nestedGridContainer = parentElement.children[0];
        nestedGrids[index] = nestedGridContainer;

        // fill the orders depending on the id.
        let suGridDataField = [
            {name: 'type', type: 'string'},
            {name: 'price', type: 'string'}, ,

        ];


        // Calculate column widths: Type gets fixed width, Price gets 20% of remaining, sizes share the rest equally
        const sizeCount = getValues('size').length;
        const typeWidth = 80;
        const totalDynamicColumns = sizeCount + 1; // sizes + Total Qty
        // When only 1 size, give price more room; otherwise cap at 20%
        const pricePercent = totalDynamicColumns <= 2 ? 30 : 20;
        const priceWidth = pricePercent + '%';
        const sizeWidthPercent = (100 - pricePercent) / totalDynamicColumns;
        const sizeWidth = sizeWidthPercent + '%';

        let subGridColumns = [
            {
                text: '<strong>Type</strong>', datafield: 'type', editable: false, width: typeWidth,
            },
            {text: '<strong>Price</strong>', datafield: 'price', editable: false,  cellsalign: 'right',    align: 'center', cellsformat: 'c2', width: priceWidth},

        ];
        const committedQuantities=getValues('committed_quantity')
        // The image row is always the first row in the sub-grid data
        const imageRowIndex = 0;

        getValues('size').forEach(item => {
            suGridDataField.push({name: item.id, type: 'number'});
            let committedText=""
            const committedQuantity =committedQuantities.find(x => (x.colour_id == record.colour_id && x.size_id==item.id));
           if(committedQuantity && committedQuantity.quantity > 0){
               committedText= "<b title='commited Quantity'>("+committedQuantity.quantity+")</b>";
           }

            subGridColumns.push({
                text: '<strong>' + item.name +committedText+'</strong>', datafield: item.id, width: sizeWidth,  cellsalign: 'right',align: 'center',
                cellbeginedit: function (row, datafield, columntype, value) {
                    if (row === imageRowIndex) return false;
                    return hasEditPermission && !hasMysteryTag ?(row == 1):false;
                },
                cellsrenderer(row, columnfield, value, defaulthtml, columnproperties) {
                    if (row === imageRowIndex) {
                        const currentSizeImages = getValues('variation_configurations')[index]?.size_images || {};
                        const sizeImg = currentSizeImages[columnfield];
                        const imgSrc = sizeImg && sizeImg.image ? sizeImg.image : require('../../../../../assets/images/default-medium-product.jpeg');
                        return ReactDOMServer.renderToString(
                            <div style={{ textAlign: 'center', marginTop: 3, cursor: 'pointer' }}>
                                <img className="img-fluid" src={imgSrc} width="30" height="30" alt="" />
                            </div>
                        );
                    }
                    return defaulthtml;
                },
                cellvaluechanging: function (row, datafield, columntype, oldvalue, value) {
                    if (row === imageRowIndex) return;
                    if (value) {
                        if (getValues('selling_type').length > 1 || getValues('selling_type').find(x => x.id === 2)) {
                           singlePackCalculation(value, datafield, getValues('size'), subGrid, gridRef, index)
                        } else {
                         singleCalculation(getValues('size'), value, datafield, index, subGrid);
                            subGrid.current[index].setcellvalue(1,datafield, value);
                        }
                    }
                },

            });
        });
        suGridDataField.push({name: 'total_qty', type: 'number'});
        subGridColumns.push({
            text: '<strong>Total Qty</strong>',
            datafield: 'total_qty',
            width: sizeWidth,
            editable: false,
            cellsalign: 'right'
        });


        const ordersSource = {
            datafields: suGridDataField,
            localdata: record.variations
        }
        const nestedGridAdapter = new jqx.dataAdapter(ordersSource);
        if (nestedGridContainer != null) {


            ReactDOM.render(
                <JqxGrid id="jqx_sub" ref={jqxRef => {
                    subGrid.current[index] = jqxRef;
                }} editable={true} theme='material'
                         onCellbeginedit={(event)=>{
                             const rowCell=event.args;
                             currentIndex=index;
                             currentEditedCell=rowCell.datafield;
                         }}
                         onCellendedit={(event)=>{
                             const rowCell=event.args;
                             setTimeout(()=>{
                                 setGridDataToHookForm(index);
                             },500);

                         }}
                         onCellclick={(event) => {
                             const args = event.args;
                             if (args.rowindex === imageRowIndex && args.datafield !== 'type' && args.datafield !== 'price' && args.datafield !== 'total_qty') {
                                 const sizeId = args.datafield;
                                 const currentSizeImages = getValues('variation_configurations')[index]?.size_images || {};
                                 const sizeImg = currentSizeImages[sizeId];
                                 const currentImageId = sizeImg ? sizeImg.image_id : '';
                                 let obj = {
                                     props: { isOpen: true },
                                     data: {
                                         rowIndex: index,
                                         image_id: currentImageId,
                                         colour_id: record.colour_id,
                                         size_id: sizeId
                                     }
                                 };
                                 dispatch(setMediaDialog(obj));
                             }
                         }}
                         width={'100%'} source={nestedGridAdapter} showtoolbar={false}
                         selectionmode='singlecell' columnsheight={5} columns={subGridColumns}/>,
                document.getElementById(nestedGridContainer.id)
            );

            setTimeout(() => {
                const myEle = document.getElementById(subGrid.current[index]._id);
                if(myEle) {
                    if (getValues('selling_type').length > 1 || getValues('selling_type').find(x => x.id === 2)) {
                        const singlePack = record.pack_for_single ? record.pack_for_single : 0;
                        singlePackCalculation(null, null, getValues('size'), subGrid, gridRef, index, singlePack)
                    } else {


                        subGrid.current[index].hidecolumn('type');
                        singleCalculation(getValues('size'), null, null, index, subGrid);
                    }
                    setGridDataToHookForm(index);
                }
            },1000)




        }
    };

const cellClickFunction = (data)=>{


    const boundData=data.row.bounddata;
    if(data.datafield == "image") {
        let obj = {props: {isOpen: true}, data: {rowIndex: boundData.boundindex, image_id: boundData.image_id,colour_id: boundData.colour_id}};
        dispatch(setMediaDialog(obj))
    }else if(data.datafield == "colour"){
         const colourSplit=(boundData.colour).split(" <");
        let obj = {props: {isOpen: true}, data: {rowIndex: boundData.boundindex,colour_id: boundData.colour_id, colour: colourSplit[0]}};
        dispatch(setSkuDialog(obj))
    }
   // setIsModalOpen(true)
}
    const skuOnClick=(index,colourId,colourName)=>{
        gridRef.setcellvalue(Number(index), "colour",colourName+" "+getColourStar(colourId));
    }
    const getColourStar=(colourId)=>{
        let totalSize= getValues('size').length;
        totalSize=getValues('selling_type').find(x => x.id === 2)?totalSize+1:totalSize;




        const binNumbers= getValues('bin_numbers').filter(function (item){
            return (item.colour_id==colourId) && (item.bin_number.length > 0 || item.gtn_number);
        })
        let name="GTN & Bin # not updated"
        let star='fa fa-star-o';
        if(binNumbers.length >0 ){
            let isComplete=true;
            if(binNumbers.length === totalSize) {
                binNumbers.map((item) => {
                    if (item.bin_number.length == 0 || !item.gtn_number) {
                        isComplete = false;
                    }
                })
            }else{
                isComplete = false;
            }
            star=isComplete?"fa fa-star":"fa fa-star-half-empty";
            name=isComplete?"GTN & Bin # updated":"GTN & Bin # not fully updated";

        }
        
        return "<span><i class='"+star+"' title='"+name+"'></i></span>";
    }
    const imageRemoveOnClick = (index, sizeId) => {
        const gridData = gridRef.getrowdata(Number(index));

        if (sizeId) {
            // Remove size-level image
            let variationData = getValues('variation_configurations');
            const varConfig = variationData[Number(index)];
            if (varConfig.size_images) {
                delete varConfig.size_images[sizeId];
            }
            setValue('variation_configurations', variationData);

            const myEle = subGrid.current[Number(index)] ? document.getElementById(subGrid.current[Number(index)]._id) : "";
            if (myEle) {
                subGrid.current[Number(index)].setcellvalue(0, sizeId, '');
            }
        } else {
            // Remove color-level image
            gridRef.setcellvalue(Number(index), "image", "");
            gridRef.setcellvalue(Number(index), "image_id", "");

            let colourData = [];
            getValues('color').map((rationItem, rationIndex) => {
                if (rationItem.id == gridData.colour_id) {
                    rationItem.product_image_id = null;
                }
                colourData.push(rationItem);
            });
            setValue('color', colourData);
        }

        setGridDataToHookForm(Number(index));
        let obj = {props: {isOpen: false}, data: ""};
        dispatch(setMediaDialog(obj));
    }

    const imageSelectOnClick= (index,imageId,imagePath,sizeId)=>{
        const gridData=gridRef.getrowdata(Number(index));

        if (sizeId) {
            // Size-level image selection
            let variationData = getValues('variation_configurations');
            const varConfig = variationData[Number(index)];
            if (!varConfig.size_images) varConfig.size_images = {};
            varConfig.size_images[sizeId] = { image_id: imageId, image: imagePath };
            setValue('variation_configurations', variationData);

            // Trigger sub-grid cell refresh by updating the image_id value in the image row (row 0)
            const myEle = subGrid.current[Number(index)] ? document.getElementById(subGrid.current[Number(index)]._id) : "";
            if (myEle) {
                subGrid.current[Number(index)].setcellvalue(0, sizeId, imageId);
            }
        } else {
            // Color-level image selection (existing behavior)
            gridRef.setcellvalue(Number(index), "image", imagePath);
            gridRef.setcellvalue(Number(index), "image_id", imageId);

            let colourData= [];
            getValues('color').map((rationItem, rationIndex) => {
                  if(rationItem.id == gridData.colour_id){
                      rationItem.product_image_id=imageId;
                  }
                colourData.push(rationItem);
            });

            setValue('color',colourData);
        }

        setGridDataToHookForm(Number(index));
        let obj={props:{isOpen:false},data:""};
        dispatch(setMediaDialog(obj));
    }
    useEffect(() => {
        if( document.getElementById("submit-div")) {
            document.getElementById("submit-div").addEventListener('click', (event) => {
                if(currentEditedCell) {
                    subGrid.current[currentIndex].endcelledit(1, currentEditedCell);
                }

            });
        }
    }, [])

    return (
        <Fragment>

            <div style={{width: '100%'}}>
                <JqxTable
                    datafields={datafields}
                    columns={columns}
                    data={gridDAta}
                    myGrid={gridRef}
                    getJqxRef={getJqxRef}
                    isDelete={false}
                    onCellendedit={cellEdit}
                    rowdetails={true}
                    autoheight={true}
                    initrowdetails={initrowdetails}
                    cellClickFunction={cellClickFunction}
                    cellClickDataField={['image','colour']}
                    disableCreateRow
                    rowdetailstemplate={{
                        rowdetails: '<div id="nestedGrid" style="margin: 1px,border: 1px solid black"></div>',
                        rowdetailsheight: subGridHeight,
                        rowdetailshidden: true
                    }}

                />
            </div>
            <MediaModal setValue={setValue}
                        trigger={trigger}
                        productState={productState}
                        isModalOpen={getValues('isModalOpen')}
                        imageSelectOnClick={imageSelectOnClick}
                        imageRemoveOnClick={imageRemoveOnClick}
                        getValues={getValues}></MediaModal>
            <SkuDetails   trigger={trigger} getValues={getValues}  productState={productState} setValue={setValue} skuOnClick={skuOnClick}>

            </SkuDetails>

        </Fragment>
    );
}

function areEqual(prevProps, nextProps) {
    return (JSON.stringify(prevProps.settingData) == JSON.stringify(nextProps.settingData) &&
    prevProps.hasMysteryTag === nextProps.hasMysteryTag);
    /*
    return true if passing nextProps to render would return
    the same result as passing prevProps to render,
    otherwise return false
    */
}

export default React.memo(VariationJsx, areEqual);